function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2016(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20.93,
    height: 8.59,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.227142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.465,
    y: 4.295
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8.59,
    width: 20.93,
    height: 11.37,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.465,
    y: 14.274999999999999
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 19.96,
    width: 20.93,
    height: 20.58,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4299999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.465,
    y: 30.25
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 40.54,
    width: 20.93,
    height: 24.71,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4883333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.465,
    y: 52.894999999999996
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 65.25,
    width: 20.93,
    height: 25.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.186
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.465,
    y: 77.925
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 90.6,
    width: 20.93,
    height: 26.24,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.3255555555555554
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.465,
    y: 103.72
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 116.84,
    width: 20.93,
    height: 26.62,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.186
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.465,
    y: 130.15
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 143.46,
    width: 20.93,
    height: 29.67,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.2325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.465,
    y: 158.29500000000002
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 173.14,
    width: 20.93,
    height: 30.23,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.186
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.465,
    y: 188.255
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 203.37,
    width: 20.93,
    height: 30.44,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.093
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.465,
    y: 218.59
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 233.81,
    width: 20.93,
    height: 33.12,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.093
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.465,
    y: 250.37
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 266.92,
    width: 20.93,
    height: 33.92,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9899999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.465,
    y: 283.88
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 300.84,
    width: 20.93,
    height: 35.68,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4883333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.465,
    y: 318.67999999999995
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 336.52,
    width: 20.93,
    height: 39.96,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4883333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.465,
    y: 356.5
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 376.49,
    width: 20.93,
    height: 39.97,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.61625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.465,
    y: 396.475
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 416.46,
    width: 20.93,
    height: 40.73,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.186
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.465,
    y: 436.825
  }, "\n        Avery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 457.18,
    width: 20.93,
    height: 46.15,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4883333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.465,
    y: 480.255
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 503.33,
    width: 20.93,
    height: 48.59,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4883333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.465,
    y: 527.625
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 551.92,
    width: 20.93,
    height: 48.62,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9027272727272726
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.465,
    y: 576.2299999999999
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 600.54,
    width: 20.93,
    height: 49.17,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4883333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.465,
    y: 625.125
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 649.71,
    width: 20.93,
    height: 50.29,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.61625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.465,
    y: 674.855
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.93,
    y: 0,
    width: 29.28,
    height: 37.21,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.57,
    y: 18.605
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.21,
    y: 0,
    width: 30.36,
    height: 37.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.59
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 65.39,
    y: 18.605
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.58,
    y: 0,
    width: 30.74,
    height: 37.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.3914285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 95.95,
    y: 18.605
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.32,
    y: 0,
    width: 31.29,
    height: 37.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.47
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.96499999999999,
    y: 18.605
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.61,
    y: 0,
    width: 32.05,
    height: 37.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2049999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 158.63500000000002,
    y: 18.605
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174.66,
    y: 0,
    width: 33.22,
    height: 37.21,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.536666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 191.26999999999998,
    y: 18.605
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.88,
    y: 0,
    width: 35.18,
    height: 37.21,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.908888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.47,
    y: 18.605
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 243.06,
    y: 0,
    width: 37.28,
    height: 37.21,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.3025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 261.7,
    y: 18.605
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280.34,
    y: 0,
    width: 38.68,
    height: 37.21,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.65125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 299.67999999999995,
    y: 18.605
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.01,
    y: 0,
    width: 39.38,
    height: 37.21,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.65125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 338.7,
    y: 18.605
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 358.39,
    y: 0,
    width: 44.14,
    height: 37.21,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.201666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 380.46,
    y: 18.605
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.54,
    y: 0,
    width: 48.29,
    height: 37.21,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.721
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 426.685,
    y: 18.605
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 450.83,
    y: 0,
    width: 48.94,
    height: 37.21,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.201666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 475.29999999999995,
    y: 18.605
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 499.77,
    y: 0,
    width: 49.25,
    height: 37.21,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.442
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 524.395,
    y: 18.605
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 549.02,
    y: 0,
    width: 49.62,
    height: 37.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1008333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 573.8299999999999,
    y: 18.605
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 598.64,
    y: 0,
    width: 50.62,
    height: 37.21,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.3025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 623.9499999999999,
    y: 18.605
  }, "\n        Hoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 649.26,
    y: 0,
    width: 50.74,
    height: 37.21,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.134444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 674.63,
    y: 18.605
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.93,
    y: 37.21,
    width: 47.57,
    height: 40.65,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.807142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.715,
    y: 57.535
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.93,
    y: 77.87,
    width: 47.57,
    height: 41.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.24875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.715,
    y: 98.86500000000001
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.93,
    y: 119.86,
    width: 47.57,
    height: 42.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.65
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.715,
    y: 141.16
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.93,
    y: 162.46,
    width: 47.57,
    height: 42.61,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.101666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.715,
    y: 183.76500000000001
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.93,
    y: 205.07,
    width: 47.57,
    height: 43.18,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.3975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.715,
    y: 226.66
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.93,
    y: 248.25,
    width: 47.57,
    height: 43.4,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.715,
    y: 269.95
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.93,
    y: 291.65,
    width: 47.57,
    height: 45.31,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.551666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.715,
    y: 314.30499999999995
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.93,
    y: 336.95,
    width: 47.57,
    height: 47.26,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.452
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.715,
    y: 360.58
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.93,
    y: 384.22,
    width: 47.57,
    height: 48.99,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.928333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.715,
    y: 408.71500000000003
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.93,
    y: 433.21,
    width: 47.57,
    height: 51.56,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.94625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.715,
    y: 458.99
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.93,
    y: 484.76,
    width: 47.57,
    height: 52,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.94625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.715,
    y: 510.76
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.93,
    y: 536.77,
    width: 47.57,
    height: 54.06,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.285555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.715,
    y: 563.8
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.93,
    y: 590.83,
    width: 47.57,
    height: 54.49,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.856666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.715,
    y: 618.075
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.93,
    y: 645.33,
    width: 47.57,
    height: 54.67,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.795714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.715,
    y: 672.6650000000001
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.5,
    y: 37.21,
    width: 50.73,
    height: 52.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.247142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 93.865,
    y: 63.620000000000005
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 119.23,
    y: 37.21,
    width: 52.45,
    height: 52.82,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.741666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 145.455,
    y: 63.620000000000005
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.68,
    y: 37.21,
    width: 53.52,
    height: 52.82,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.868888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 198.44,
    y: 63.620000000000005
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225.19,
    y: 37.21,
    width: 54.56,
    height: 52.82,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.803333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 252.47,
    y: 63.620000000000005
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 279.75,
    y: 37.21,
    width: 58.53,
    height: 52.82,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.803333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 309.015,
    y: 63.620000000000005
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338.28,
    y: 37.21,
    width: 58.67,
    height: 52.82,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.545714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 367.61499999999995,
    y: 63.620000000000005
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 396.95,
    y: 37.21,
    width: 59.3,
    height: 52.82,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.282
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 426.59999999999997,
    y: 63.620000000000005
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 456.24,
    y: 37.21,
    width: 59.42,
    height: 52.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.6025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 485.95,
    y: 63.620000000000005
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 515.66,
    y: 37.21,
    width: 60.12,
    height: 52.82,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.545714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 545.7199999999999,
    y: 63.620000000000005
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 575.78,
    y: 37.21,
    width: 61.23,
    height: 52.82,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.803333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 606.395,
    y: 63.620000000000005
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 637.01,
    y: 37.21,
    width: 62.99,
    height: 52.82,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.564
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 668.505,
    y: 63.620000000000005
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.5,
    y: 90.03,
    width: 60.79,
    height: 61.74,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.59875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.895,
    y: 120.9
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.5,
    y: 151.77,
    width: 60.79,
    height: 64.22,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.59875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.895,
    y: 183.88
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.5,
    y: 215.99,
    width: 60.79,
    height: 64.82,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.131666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.895,
    y: 248.4
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.5,
    y: 280.82,
    width: 60.79,
    height: 66.16,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.158
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.895,
    y: 313.9
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.5,
    y: 346.98,
    width: 60.79,
    height: 67.74,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.684285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.895,
    y: 380.85
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.5,
    y: 414.71,
    width: 60.79,
    height: 68.03,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.684285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.895,
    y: 448.72499999999997
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.5,
    y: 482.74,
    width: 60.79,
    height: 69.45,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.684285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.895,
    y: 517.465
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.5,
    y: 552.2,
    width: 60.79,
    height: 71.87,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.079
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.895,
    y: 588.135
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.5,
    y: 624.06,
    width: 60.79,
    height: 75.94,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.754444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.895,
    y: 662.03
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.3,
    y: 90.03,
    width: 62.63,
    height: 76.01,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.947142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 160.615,
    y: 128.035
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.92,
    y: 90.03,
    width: 63.9,
    height: 76.01,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.65
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 223.86999999999998,
    y: 128.035
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.82,
    y: 90.03,
    width: 64.8,
    height: 76.01,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.2
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 288.21999999999997,
    y: 128.035
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.62,
    y: 90.03,
    width: 66.2,
    height: 76.01,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 353.72,
    y: 128.035
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 386.82,
    y: 90.03,
    width: 68.91,
    height: 76.01,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.782
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 421.275,
    y: 128.035
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 455.73,
    y: 90.03,
    width: 77.67,
    height: 76.01,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.668333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 494.565,
    y: 128.035
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 533.4,
    y: 90.03,
    width: 79.09,
    height: 76.01,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.445555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 572.9449999999999,
    y: 128.035
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 612.49,
    y: 90.03,
    width: 87.51,
    height: 76.01,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.202000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 656.245,
    y: 128.035
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.3,
    y: 166.05,
    width: 83.57,
    height: 79.85,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.98125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.085,
    y: 205.97500000000002
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.3,
    y: 245.9,
    width: 83.57,
    height: 84.52,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.285555555555554
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.085,
    y: 288.16
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.3,
    y: 330.41,
    width: 83.57,
    height: 87.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.44625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.085,
    y: 374.40500000000003
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.3,
    y: 418.4,
    width: 83.57,
    height: 89.46,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.938571428571427
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.085,
    y: 463.13
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.3,
    y: 507.87,
    width: 83.57,
    height: 92.56,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.44625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.085,
    y: 554.15
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.3,
    y: 600.43,
    width: 83.57,
    height: 99.57,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.8925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.085,
    y: 650.2149999999999
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.87,
    y: 166.05,
    width: 91.05,
    height: 93.46,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.174999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.395,
    y: 212.78
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303.92,
    y: 166.05,
    width: 91.3,
    height: 93.46,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.042857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 349.57,
    y: 212.78
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 395.22,
    y: 166.05,
    width: 95,
    height: 93.46,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.6825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 442.72,
    y: 212.78
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 490.21,
    y: 166.05,
    width: 103.16,
    height: 93.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.6825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 541.79,
    y: 212.78
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 593.37,
    y: 166.05,
    width: 106.63,
    height: 93.46,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.576666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 646.685,
    y: 212.78
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.87,
    y: 259.51,
    width: 113.56,
    height: 96.19,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.238
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 269.65,
    y: 307.605
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.87,
    y: 355.7,
    width: 113.56,
    height: 101.83,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.257272727272728
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 269.65,
    y: 406.615
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.87,
    y: 457.53,
    width: 113.56,
    height: 116.03,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.356
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 269.65,
    y: 515.545
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.87,
    y: 573.56,
    width: 113.56,
    height: 126.44,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.195
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 269.65,
    y: 636.78
  }, "\n        Buncombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 326.43,
    y: 259.51,
    width: 98.55,
    height: 163.73,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 375.705,
    y: 341.375
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 424.98,
    y: 259.51,
    width: 112.55,
    height: 163.73,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.07857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 481.255,
    y: 341.375
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 537.53,
    y: 259.51,
    width: 162.47,
    height: 163.73,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.30875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 618.765,
    y: 341.375
  }, "\n        Guilford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 326.43,
    y: 423.23,
    width: 176.56,
    height: 276.77,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.05090909090909
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 414.71000000000004,
    y: 561.615
  }, "\n        Mecklenburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 502.99,
    y: 423.23,
    width: 197.01,
    height: 276.77,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 49.2525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 601.495,
    y: 561.615
  }, "\n        Wake\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2016);
export default __webpack_public_path__ + "static/media/2016.2090d9286c6b2207e582992d446b2437.svg";
export { ForwardRef as ReactComponent };